import {setFormData} from "../formData/actions";

export const getConfig =
  (loadingId: string, root_code: string, mode: string, body:any = {}) =>
    ({ fetch }) => {
        console.log('Inside Actions getConfig', loadingId, root_code, mode)
        return {
            type: '@formPage/UPDATE',
            payload: {
                promise: fetch(`forms/page/${root_code}/${mode}`, {
                    method: 'POST',
                    body,

                }).then((res) => {

                    return res;
                }).catch((error) => {
                    console.log('[FORM ERROR]', error.status, error)
                    return Promise.reject(error)
                }),
                data: {loadingId}
            }
        };
    };
export const getDevSubmissions =
    (d:any, root_code: string, form_code:string, recordId:string, body:any = {}) =>
        ({ fetch }) => {

            console.log('Inside Actions getDevSubmissions', root_code)
            return {
                type: '@formPage/UPDATE',
                payload: fetch(`forms/page/devsubmission/${root_code}/${recordId}`, {
                    method: 'POST',
                    body,

                }).then((res) => {
                    d(setFormData(`${recordId}_submission_response`, root_code,form_code, false,  {...res.response} ) as any)
                    return res.form;
                }),
            };
        };
export const resetFormId =
    (prevId: string, newId: string) =>
        (action) => {

            return {
                type: '@formPage/UPDATED_ID',
                payload: {prevId,newId}
            };
        };

export const clearForm =
    (formId: string) =>
        ({getState}) => {
            console.log('DELETING FORM CONFIG', formId)
            return {
                type: '@formPage/DELETE_SUCCESS',
                payload: formId
            };
        };